import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { TruncatedText } from 'site-modules/shared/components/truncated-text/truncated-text';

import './reviews-list-item.scss';

const MAX_TEXT_LENGTH = {
  MOBILE: 200,
  DESKTOP: 190,
};

export const ReviewsListItem = ({ text, date, rating, isMobile = false }) => {
  const maxTextLength = isMobile ? MAX_TEXT_LENGTH.MOBILE : MAX_TEXT_LENGTH.DESKTOP;

  return (
    <div className="reviews-list-item py-1">
      <div className="mb-0_5">
        {!Number.isNaN(rating) && <RatingStars rating={rating} className="size-14 text-cool-gray-30 me-1" />}
        <span className="size-14 text-cool-gray-50">{dateFormat(date, 'mmm d, yyyy')}</span>
      </div>
      <div className="size-16 text-cool-gray-30">
        {text.length > maxTextLength ? (
          <TruncatedText
            text={text}
            btnTextMore="Read more"
            btnTextLess="Read less"
            btnClassName="text-blue-50 size-16 border-0 mt-0_5"
            indicatorOpenClass="icon-arrow-down3 size-12 ps-0_5"
            indicatorCloseClass="icon-arrow-up3 size-12 ps-0_5"
            maxTextLength={maxTextLength}
            expandAriaLabel="Read more of review"
            collapseAriaLabel="Read less of review"
            expandTrackingId="view_review_details"
            expandTrackingValue="Read more"
          />
        ) : (
          text
        )}
      </div>
    </div>
  );
};

ReviewsListItem.propTypes = {
  text: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
};
